import {
  SubscriptionPaymentRestControllerService,
  SubscriptionRestControllerService,
} from 'generated';
import localforage from 'localforage';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient, { apiWrapper } from 'utils/http-client';
import {
  getCurrentTermFail,
  getCurrentTermSuccess,
  handleCurrentSubscription,
  handleCurrentSubscriptionCheckout,
} from '../actions';
import configActionTypes from '../types';

const dummy_sub = {
  id: 'c8585a3d-511b-4324-a7c0-d2ebed795da5',
  term: {
    session_id: '2024-2025',
    term_id: 'd9e477e9-604a-4982-8d32-0dd726f01e34',
    term_name: 'First Term',
  },
  pricing_model: 'STANDARD_PER_STUDENT',
  subscription_plan: {
    id: 'STANDARD',
    max_student_count: null,
    currency_student_count_amount_map: {
      GHC: {
        51: 20.0,
        250: 19.0,
        500: 18.0,
      },
      NGN: {
        51: 2000.0,
        250: 1900.0,
        500: 1800.0,
      },
      KES: {
        51: 200.0,
        250: 190.0,
        500: 180.0,
      },
      USD: {
        51: 10.0,
        250: 9.0,
        500: 8.0,
      },
    },
    features: [
      'RESULT_MANAGEMENT',
      // 'FEES_MANAGEMENT',
      // 'CBT',
      'STAFF_MANAGEMENT',
      // 'MESSAGING',
      'LESSON_PLAN',
      'PARENT_MANAGEMENT',
      'STUDENT_MANAGEMENT',
      'ATTENDANCE',
    ],
  },
  is_trial: false,
  trial_expiry_date: null,
  grace_expiry_date: '2025-04-26T23:59:59.999999999',
  current_system_date: '2025-04-21T02:45:49.017649',
  is_blocked: false,
};

export function* getcurrentTerm() {
  try {
    const response = yield httpClient.get('terms/current-term');
    const termId = response?.data?.term_id;
    yield put(getCurrentTermSuccess(response.data));

    if (response?.data?.term_id) {
      try {
        const access_token = yield localforage.getItem('access_token');

        if (access_token) {
          // To ensure the call is made when token is present
          const response_2 = yield apiWrapper(() =>
            SubscriptionRestControllerService.getSubscriptionUsingGet({
              termId: response?.data?.term_id,
            }),
          );
          yield put(handleCurrentSubscription(response_2));
          if (response_2?.subscription?.id) {
            const response_3 = yield apiWrapper(() =>
              SubscriptionPaymentRestControllerService.getCheckoutResponseUsingGet({
                termId: response?.data?.term_id,
              }),
            );
            yield put(handleCurrentSubscriptionCheckout(response_3));
          }
        } else {
          yield put(handleCurrentSubscription({}));
          yield put(handleCurrentSubscriptionCheckout({}));
        }
      } catch (error) {
        yield put(handleCurrentSubscription({}));
        yield put(handleCurrentSubscriptionCheckout({}));
      }
    }
  } catch (error) {
    yield put(getCurrentTermFail(error?.message));
  }
}

export function* onGetcurrentTerm() {
  yield takeLatest(configActionTypes.GET_CURRENT_TERM_START, getcurrentTerm);
}
